import { AlertMetadata } from './alert-metadata.interface';
import { ICommentDto } from './create-auditable-dto.interface';
import { AlertTypesEnum, AuditableStatus } from '../enums';

export interface ICreateAlertDto {
    organizationId: string;
    type: AlertTypesEnum;
    trip?: string;
    device?: string;
    stepName: string;
    comments?: ICommentDto[];
    source: string;
    createdBy?: string;
    sequenceId?: number;
    resolvedBy?: string;
    resolvedAt?: string;
    vehicle?: {
        id: string;
        licensePlate: string;
        name?: string;
    };
    driver?: {
        id: string;
        fullName: string;
    };
    metadata?: AlertMetadata;
}

export interface IUpdateAlertDto extends Partial<ICreateAlertDto> {
    status: AuditableStatus;
    resolvedBy?: string;
    resolvedAt?: string;
}
